import { useEffect, useLayoutEffect, useRef } from "react";
import "./auslassung.css";

/**
 * Kompakt-Ebene (D-1, Inhaber 21.10.2026): Texte mit der Klasse „tk-ell“ stehen einzeilig mit Auslassung („…“) oder auf wenige Zeilen gekürzt (line-clamp).
 * Ist ein solcher Text tatsächlich abgeschnitten, bekommt er den vollen Text als Tooltip (title); passt er wieder, fällt der
 * Tooltip weg. Ein von Hand gesetzter title bleibt unberührt. Geprüft nach jedem Zeichnen und bei jeder Größenänderung.
 */
export function useAuslassungTitel<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const pruefe = () => {
    const wurzel = ref.current;
    if (!wurzel) return;
    for (const el of wurzel.querySelectorAll<HTMLElement>(".tk-ell")) {
      const zuLang = el.scrollWidth > el.clientWidth + 1 || el.scrollHeight > el.clientHeight + 1;
      if (zuLang && (!el.title || el.dataset.autoTitel)) {
        el.title = (el.textContent ?? "").replace(/\s+/g, " ").trim();
        el.dataset.autoTitel = "1";
      } else if (!zuLang && el.dataset.autoTitel) {
        el.removeAttribute("title");
        delete el.dataset.autoTitel;
      }
    }
  };
  useLayoutEffect(pruefe);
  useEffect(() => {
    const wurzel = ref.current;
    if (!wurzel || typeof ResizeObserver === "undefined") return;
    const beobachter = new ResizeObserver(() => pruefe());
    beobachter.observe(wurzel);
    return () => beobachter.disconnect();
  }, []);
  return ref;
}
